import { useInterviewAgent } from '@/store/InterviewAgent';
import { Flex, Steps } from '@chakra-ui/react';

const steps = [
  {
    title: 'Interview Details'
  },
  {
    title: 'Audio & Video Test'
  },
  {
    title: 'Practice Question'
  },
  {
    title: 'Start Interview'
  }
];

export default function Stepper({ ...props }) {
  const { step, setStep } = useInterviewAgent();

  return (
    <Flex direction="column" align="center" justify="center" {...props}>
      <Steps.Root
        colorPalette="blue"
        color="primary.900"
        step={step}
        onStepChange={(e) => setStep(e.step)}
        count={steps.length}
      >
        <Steps.List>
          {steps.map((item, index) => (
            <Steps.Item key={index} index={index} title={item.title}>
              <Steps.Indicator
                bg={step > index ? 'primary.900' : 'transparent'}
                borderColor={step >= index ? 'primary.900' : 'neutrals.500'}
                color={step > index ? 'white' : step === index ? 'primary.900' : 'neutrals.500'}
                fontSize="16px"
              />
              <Steps.Title fontSize="16px" color={step >= index ? 'neutrals.900' : 'neutrals.500'}>
                {item.title}
              </Steps.Title>
              <Steps.Separator bg={step > index ? 'primary.900' : 'neutrals.500'} />
            </Steps.Item>
          ))}
        </Steps.List>
      </Steps.Root>
    </Flex>
  );
}
